import {
  TrialRunDisplayStatus,
  type TrialRunDisplayRow,
} from "./buildTrialRunRow";

export const selectRowsForLedger = (rows: TrialRunDisplayRow[]): string[] =>
  rows
    .filter(
      row =>
        row.displayStatus !== TrialRunDisplayStatus.Error &&
        row.displayStatus !== TrialRunDisplayStatus.Ledgered,
    )
    .map(row => row.id);
